export default "__VITE_ASSET__CWuI1Nd4__"